import React, { useState } from "react";
import faqImage from "../../assets/img/faq.png";
import "./FaqSection.css";

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "What types of courses do you offer?",
      answer:
        "We offer a wide range of courses including Web Development, Data Science, Graphic Design, Digital Marketing, and Programming Languages like Python, Java, and more."
    },
    {
      question: "Are the courses self-paced or live?",
      answer:
        "Our platform provides both self-paced and live instructor-led classes, so you can choose the format that suits your learning style and schedule."
    },
    // {
    //   question: "Do I get a certificate after course completion?",
    //   answer:
    //     "Yes, all our paid courses come with a verifiable certificate of completion, which you can download and share on LinkedIn or with potential employers."
    // },
    {
      question: "Is there any free trial or demo class available?",
      answer:
        "Yes, we offer a free demo class or sample videos for most of our courses. You can experience the content before making a purchase."
    },
    {
      question: "How can I access the course materials?",
      answer:
        "Once enrolled, you can access all course materials — including video lectures, assignments, and quizzes — directly through your dashboard anytime, anywhere."
    }
  ];

  return (
    <section className="faqs py-5">
      <div className="container">
        {/* Section Title */}
        <div className="row justify-content-center mb-4">
          <div className="col-lg-8 text-center">
            <h2 className="font-weight-bold">
              Frequently Asked <span>Questions</span>
            </h2>
            <p className="text-muted">
              Have questions about our courses or learning platform? Find answers to the most common queries below.
            </p>
            <div className="faq-underline">
              <div className="circle-question">?</div>
            </div>
          </div>
        </div>

        {/* FAQ Content */}
        <div className="row align-items-center">
          <div className="col-lg-5 mb-4 mb-lg-0">
            <img src={faqImage} alt="FAQ" className="img-fluid" />
          </div>
          <div className="col-lg-7">
            <div id="faqAccordion">
              {faqItems.map((item, i) => {
                const isOpen = openIndex === i;
                return (
                  <div className="card mb-2" key={i}>
                    <div className={`card-header ${isOpen ? "active" : ""}`} id={`heading${i}`}>
                      <h5 className="mb-0">
                        <button
                          className={`btn btn-link d-flex align-items-center ${!isOpen ? "collapsed" : ""}`}
                          type="button"
                          onClick={() => handleToggle(i)}
                        >
                          <i className="fa fa-question mr-2 icon-circle"></i>
                          {item.question}
                        </button>
                      </h5>
                    </div>
                    <div
                      id={`collapse${i}`}
                      className={`collapse ${isOpen ? "show" : ""}`}
                      aria-labelledby={`heading${i}`}
                    >
                      <div className="card-body">
                        {item.answer}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
